import type { LexicalEditorType } from "@forento/ui/components/LexicalEditor"

type EditorState = Parameters<typeof import("@forento/core/utilities/lexical/interactive")["isEditorStateEmpty"]>[0]

export async function loadLazyEditorState(editor: LexicalEditorType, value: string | null) {
	const { loadEditorState } = await import("@forento/core/utilities/lexical/interactive")
	loadEditorState(editor, value)
}

export async function isLazyEditorStateEmpty(editorState: EditorState) {
	const { isEditorStateEmpty } = await import("@forento/core/utilities/lexical/interactive")
	return isEditorStateEmpty(editorState)
}

export async function exportLazyEditorState(editor: LexicalEditorType) {
	const { exportEditorState } = await import("@forento/core/utilities/lexical/interactive")
	return exportEditorState(editor.getEditorState())
}
